import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import TrustCompliance from "@/pages/TrustCompliance";
import TrustAttorneys from "@/pages/TrustAttorneys";
import RealEstateAttorneys from "@/pages/RealEstateAttorneys";
import CorporateAttorneys from "@/pages/CorporateAttorneys";
import Pricing from "@/pages/Pricing";
import Security from "@/pages/Security";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/trust-compliance" element={<TrustCompliance />} />
          <Route path="/trust-attorneys" element={<TrustAttorneys />} />
          <Route path="/real-estate-attorneys" element={<RealEstateAttorneys />} />
          <Route path="/corporate-attorneys" element={<CorporateAttorneys />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/security" element={<Security />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
